const Event = require("util/Event");
const Misc = require("util/Misc");

const FireAuth = {
    init : function(){
        firebase.auth().onAuthStateChanged(function(user) {
            if (user) {
                // User is signed in.
                //console.log("user is in");
            } else {
                // No user is signed in.
                //console.log("NO USER");
            }
            FireAuth.profileUpdated();
        });
    },

    addUserWatcher : function(cb){
        if(!FireAuth.userWatchers)
            FireAuth.userWatchers = [];
        FireAuth.userWatchers.push(cb);
        if(window.firebase) { // firebase was initialized and this can be called.
            try{
                cb(FireAuth.authenticatedUser());
            }catch(e){
                console.error(e);
            }
        }
    },

    profileUpdated(){
        let n = (FireAuth.userWatchers) ? FireAuth.userWatchers.length : 0;
        for(let i = 0; i < n; i++) {
            let cb = FireAuth.userWatchers[i];
            cb(FireAuth.authenticatedUser());
        }
    },

    reAuth(pass, cb){
        const user = FireAuth.authenticatedUser();
        if(user){
            const credential = firebase.auth.EmailAuthProvider.credential(user.email, pass);
            user.reauthenticateWithCredential(credential).then(function(val){
                cb(val);
            }).catch(function(error) {
                cb(error);
            });
        }
    },

    reAuthWithPopup(cb){
        const user = FireAuth.authenticatedUser();
        if(user){
            let providerData = user.providerData[0];
            let providerId = providerData.providerId;
            let provider = null;
            console.log(providerId);
            if(providerId === 'google.com'){
                provider = new firebase.auth.GoogleAuthProvider();
            }
            if(provider){
                user.reauthenticateWithPopup(provider).then(function(val){
                    cb(val);
                }).catch(function(error) {
                    cb(error);
                });
            }
        }
    },

    deleteUser(cb){
        const user = FireAuth.authenticatedUser();
        if(user){
            user.delete().then(function(val){
                cb(val);
            }).catch(function(error) {
                cb(error);
            });
        }
    },

    updatePassword(newPass, cb){
        const user = FireAuth.authenticatedUser();
        if(user){
            user.updatePassword(newPass).then(function(val){
                cb(val);
            }).catch(function(error) {
                cb(error);
            });
        }
    },

    authenticatedUser : function(){
        return (window.firebase && firebase.auth()) ? firebase.auth().currentUser : null;
    },

    signIn : function(email, password, cb){
        firebase.auth().signInWithEmailAndPassword(email, password).then(function(val){
            cb(true);
        }).catch(function(error) {
            console.log(error);
            cb(error.message);
        });
    },

    resetPass : function(email, cb){
        var auth = firebase.auth();
        auth.sendPasswordResetEmail(email).then(function() {
            cb();
        }).catch(function(error) {
            cb(error);
        });
    },

    signUpWithEmailPassword(email, pass, cb){
        firebase.auth().createUserWithEmailAndPassword(email, pass).then(function(val){
            cb(true);
        }).catch(function(error) {
            console.log(error);
            cb(error.message);
        });
    },

    signOut : function(cb){
        firebase.auth().signOut().then(function() {
            // Sign-out successful.
            if(cb)
                cb(true)
        }).catch(function(error) {
            // An error happened.
            if(cb)
                cb(error.message);
        });
    },

    authGoogle : function(cb){
        var provider = new firebase.auth.GoogleAuthProvider();
        FireAuth.signInWithProvider(provider, function(response){
            cb(response);
        });
    },

    authFacebook(cb){
        var provider = new firebase.auth.FacebookAuthProvider();
        FireAuth.signInWithProvider(provider, function(response){
            cb(response);
        });
    },

    signInWithProvider : function(provider, cb){
        firebase.auth().signInWithPopup(provider).then(function(result) {
            cb(true);
        }).catch(function(error) {
            var errorMessage = error.message;
            cb(errorMessage);
        });
    },

};

module.exports = FireAuth;


// WEBPACK FOOTER //
// ./src/control/util/FireAuth.js